'use client';

import { Box, Container, VStack } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import Slider from '@/_components/Slider';
import { IRecipe } from '@/_types';
import RecipeDetails from '../RecipeDetails';
import RecipeSteps from '../RecipeSteps';
import type { RecipeReviewsPayload } from '../types';
import UniversalHeader from '@/_components/Header';
import { useCustomLocale } from '@/shared/hooks/use-custom-locale';

export default function Mobile({
  data,
  reviews,
}: {
  data: IRecipe;
  reviews?: RecipeReviewsPayload;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [maxImgH, setMaxImgH] = useState('280px');
  const currentLocale = useCustomLocale();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const resizeObs = new ResizeObserver(([entry]) => {
      const w = entry.contentRect.width;
      setMaxImgH(`${Math.min(w * (2 / 3), 360)}px`);
    });
    resizeObs.observe(el);
    return () => resizeObs.disconnect();
  }, [data?.images]);

  return (
    <Box bg={'background'} minH={'100vh'} pb={10}>
      <UniversalHeader
        backLink='/recipes'
        title={data.title?.[currentLocale]}
      />
      <Box ref={ref}>
        {data?.images?.length > 0 && (
          <Slider list={data.images} maxHeight={maxImgH} aspectRatio={3 / 2} />
        )}
      </Box>
      <Container mt={6} mb={8}>
        <VStack align='stretch' gap={6}>
          <RecipeDetails data={data} reviews={reviews} />
          <RecipeSteps data={data} />
        </VStack>
      </Container>
    </Box>
  );
}
